import React, { useState, useEffect } from 'react';
import {
  FacebookOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  TwitterOutlined,
  YoutubeOutlined,
} from '@ant-design/icons';
import useContent from '../../../../core/hooks/useContent';

const Footer: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [lastTouchY, setLastTouchY] = useState<number>(0);
  const content = useContent()
  const handleWheel = (e: WheelEvent) => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (documentHeight <= windowHeight && e.deltaY > 0) {
      setIsVisible(true);
    }

    if (e.deltaY < 0) {
      setIsVisible(false);
    }
  };

  const handleTouchStart = (e: TouchEvent) => {
    const touchY = e.touches[0].clientY;
    setLastTouchY(touchY);
  };

  const handleTouchMove = (e: TouchEvent) => {
    const touchY = e.touches[0].clientY;

    if (touchY < lastTouchY) {
      setIsVisible(true);
    }

    if (touchY > lastTouchY) {
      setIsVisible(false);
    }

    setLastTouchY(touchY);
  };

  const handleScroll = () => {
    const scrollY = window.scrollY;
    const lastScrollY = (window as any).lastScrollY || 0;

    if (scrollY > lastScrollY) {
      setIsVisible(true);
    }

    if (scrollY < lastScrollY) {
      setIsVisible(false);
    }

    (window as any).lastScrollY = scrollY;
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('wheel', handleWheel);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [lastTouchY]);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 bg-primary flex justify-between items-center py-5 px-10 h-7 z-50 transition-transform duration-300 ease-in-out ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="w-4/5 max-lg:w-full">
        <p className="text-sm max-lg:text-xs text-white">
          {content('hedefnet.profile.copyright')}
        </p>
      </div>
      <ul className="list-none flex text-white text-base max-lg:w-full w-1/5 justify-between  ">
        <li
          className="cursor-pointer"
          onClick={() =>
            window.open(
              'https://www.linkedin.com/company/341544?trk=tyah&trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A341544%2Cidx%3A1-1-1%2CtarId%3A1466411914436%2Ctas%3Ahedef%20filo',
              '_blank'
            )
          }
        >
          <LinkedinOutlined />
        </li>

        <li
          className="cursor-pointer"
          onClick={() =>
            window.open(
              'https://www.youtube.com/@hedeffiloarackiralama',
              '_blank'
            )
          }
        >
          <YoutubeOutlined />
        </li>
        <li
          className="cursor-pointer"
          onClick={() =>
            window.open('https://www.facebook.com/Hedeffilo', '_blank')
          }
        >
          <FacebookOutlined />
        </li>
        <li
          className="cursor-pointer"
          onClick={() => window.open('https://x.com/HedefFilo', '_blank')}
        >
          <TwitterOutlined />
        </li>
        <li
          className="cursor-pointer"
          onClick={() =>
            window.open('https://www.instagram.com/Hedeffilo', '_blank')
          }
        >
          <InstagramOutlined />
        </li>
      </ul>
    </div>
  );
};

export default Footer;
